module.exports = __webpack_public_path__ + "img/32.ebe1f075.png";